import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { useMemo } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router';
import { tailwindConfig } from 'tailwind-config';

import { ROUTE_PATHS } from 'shared/consts/routes';
import { useTypedSelector } from 'store';

import { DocumentIcon } from 'assets/icons';

/**
 * Sidebar navigation item for the global Reports page.
 * Visible to admin users only (controlled by parent Sidebar).
 */
const ReportsSideBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isSidebarOpened = useTypedSelector(store => store.ui.isSidebarOpened);

  const reportsPathIsActive: boolean = useMemo(
    () => Boolean(matchPath(`${ROUTE_PATHS.reports}/*`, pathname)),
    [pathname],
  );

  return (
    <div
      className={cn('mm-sidebar__menu__item', { _active: reportsPathIsActive })}
      onClick={() => navigate(ROUTE_PATHS.reports)}
    >
      <div className="mm-sidebar__menu__item__left">
        <div className="mm-sidebar__menu__item__icon">
          <DocumentIcon
            color={reportsPathIsActive ? tailwindConfig.theme.colors.primary : undefined}
          />
        </div>
        <AnimatePresence>
          {isSidebarOpened && (
            <motion.span
              exit={{ opacity: 0, width: 0 }}
              transition={{ duration: isSidebarOpened ? 0.25 : 0 }}
              className="mm-sidebar__menu__item__text"
            >
              Reports
            </motion.span>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export { ReportsSideBar };
